import { Box, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import "./styles.scss";
import { LoadingButton } from "@mui/lab";
import { getSettingsDetails } from "../../services/settingsService";
import { SettingsDetailsType } from "../../types/genericType";
import { updateCheckNumber } from "../../services/batchService";

const TableFilters = ({
  initialLoad,
}: {
  search: string;
  // eslint-disable-next-line no-unused-vars
  onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  clearSearch: Function;
  initialLoad: Function;
}) => {
  const [settingsData, setSettingsData] = useState<SettingsDetailsType>({
    LoanMessage: "",
    InvestmentMessage: "",
    Quote: "",
    NextCheckNumber: 0,
    StatementEmailSubject: "",
    StatementEmailBody: "",
    MonthEndDescription: "",
    ManagementFees: "",
    ManagementRate: "",
    VariableInvestmentRate: "",
    TotalRate: "",
    CompanyEmail: "",
    ManagementFirm: "",
  });
  const [nextCheck, setNextCheck] = useState(
    settingsData?.NextCheckNumber.toString() || ""
  );

  const getSettingsData = () => {
    getSettingsDetails()
      .then((res: SettingsDetailsType) => {
        setSettingsData(res);
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getSettingsData();
  }, []);

  useEffect(() => {
    setNextCheck(settingsData?.NextCheckNumber.toString() || "");
  }, [settingsData]);

  const updateNextCheckNumber = () => {
    updateCheckNumber(nextCheck)
      .then(() => {
        getSettingsData();
        initialLoad();
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  return (
    <Box className="headding-row">
      <Typography variant="h5" component="h4">
        Checks
      </Typography>
      <Box className="filters">
        <TextField
          size="small"
          variant="outlined"
          label="Next Check#"
          value={nextCheck}
          onChange={(event) => setNextCheck(event.target.value as string)}
          sx={{ width: "186px" }}
        />
        <LoadingButton
          variant="contained"
          data-testid="createTxnBtn"
          size="small"
          className="create-button"
          onClick={() => {
            updateNextCheckNumber();
          }}
          sx={{ width: "186px", height: "40px" }}
        >
          Update
        </LoadingButton>
      </Box>
    </Box>
  );
};

export default TableFilters;
